import EditTemplate from './EditTemplate';
import EditTemplateController from './EditTemplateController';

export { EditTemplate };

export default EditTemplateController;
